import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Modal, Pagination, Dimmer, Loader, Segment, Header, Icon, Table, Button, Grid, Confirm } from 'semantic-ui-react'
import closeIcon from '../../../assets/images/newui/close.png'
import "./DispatchWithNoteModal.less"
import { getSCRequestNotesList } from '../../../services/Seller'
import moment from 'moment';
import Formsy from 'formsy-react';
import DGTextarea from 'components/FormControls/TextareaStepByStep/DGTextareaStepByStep';

function DispatchWithNoteModal({ handleRequestDispatch, selectedDriver, submitButtonText, placeholder, label, selectedRequest, isOpen, onClose, header }) {

  const [requestNotesState, setRequestNotesState] = useState([]);
  const [noteState, setNoteState] = useState("");

  const loadData = async (scRequestID) => {
    let res = await getSCRequestNotesList(scRequestID);
    if (res.resStatus == 200) {
      console.log("res.data", res.data)
      setRequestNotesState(res.data);
    }
  }
  const handleNoteChange = (data) => {
    setNoteState(data.value)
  }

  useEffect(() => {
    if (isOpen && selectedRequest && selectedRequest.scRequestID) {
      console.log("selectedRequest", selectedRequest)
      loadData(selectedRequest.scRequestID);
      setNoteState("")
    }
  }, [isOpen, selectedRequest])

  return (
    <Modal
      open={isOpen}
      closeOnDimmerClick={false}
      onClose={() => onClose()}
      className="request-dispatch-notes-modal">

      <div>
        <div className="header">
          <div
            className="close-button"
            onClick={() => onClose()}
          >
            <img src={closeIcon}></img>
          </div>
          <div className="main-heading">{header || "Additional Details"} </div>
        </div>

        <div className="body">

          <div className='container'>
            <Formsy>
              <div className='current-driver-container'>
                <div className='heading'> {selectedDriver?.firstName + " " + selectedDriver?.lastName}</div>
                <div>
                  <Icon className='phone-icon' name='phone'></Icon> {selectedDriver?.cellPhone}
                </div>
                <div className='text'> <Icon className='phone-icon' name='mail'></Icon> {selectedDriver?.email}</div>
              </div>
              <div id={"additional-detail-text-area_id"} >
                <DGTextarea
                  name={`seller-notes-text-area`}
                  label={label || `Additional Details`}
                  value={noteState}
                  onChange={(e, data) => {
                    handleNoteChange(data);
                  }}
                  {...{
                    maxLength: 10000,
                    placeholder: placeholder || "Additional details",
                  }}
                ></DGTextarea>
              </div>
              <div className="btn-container">
                <button
                  type="button"
                  className="button-submit"
                  onClick={() => handleRequestDispatch(noteState)}
                >
                  {submitButtonText || "Continue"}
                </button>
              </div>
            </Formsy>
            <div>
              <div className='notes-heading'>Notes</div>
              <div className='notes-container'>
                {
                  requestNotesState && requestNotesState.length > 0 ?
                    <Table celled>

                      {
                        window.innerWidth < 768 ? <></> :
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell style={{
                                width: "50%"
                              }}>Created At</Table.HeaderCell>
                              <Table.HeaderCell>
                                Message
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                      }
                      <Table.Body>
                        {
                          requestNotesState.map((note) => {
                            return <>
                              <Table.Row>
                                <Table.Cell>{moment(note.createdAt).format('LLL')}</Table.Cell>
                                <Table.Cell>{note.message}</Table.Cell>
                              </Table.Row>
                            </>
                          })
                        }
                      </Table.Body>
                    </Table> : <>
                      <div className='no-notes-container'>
                        <div> {"No notes yet"}</div>
                      </div>
                    </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DispatchWithNoteModal